// extracted by mini-css-extract-plugin
export var tabsPanel = "_30jVAonM";
export var letterBtn = "cNZ6qJCo";
export var letter = "_3wT7QfBg";